import React from "react";

import { Toast } from "@/mk2/components/toasts/Toast";
import { ERROR_COULD_NOT_PERFORM_ACTION } from "@/mk/autogenerated/translation";

export interface OwnProps {
    remove();
}

type Props = OwnProps;

export const ServerErrorToast: React.StatelessComponent<Props> = ({ remove }) => (
    <Toast type="error" remove={remove}>
        {ERROR_COULD_NOT_PERFORM_ACTION}
    </Toast>
);
